import mimeModule from 'mime';

const mime = mimeModule as unknown as { getType(path: string): null | string };

export function resolveMimeType(path: string, fallback = 'application/octet-stream'): string {
	return mime.getType(path) ?? fallback;
}
